module.exports = __webpack_public_path__ + "img/cph_concept_hero_billede.ee0ff4fa.jpg";